export default __webpack_public_path__ + "static/4-f2cb2b1578d9251e9997792f2fb2f278.png";